// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nq-1";
export var messageSideRight = "_nq-2";
export var subscribeToBackInStockBubbleContainer = "_nq-0";